export interface ArticleMeta {
  slug: string;
  image: string;
  updated: string;
}

export const articles: ArticleMeta[] = [
  {
    slug: 'usfans-spreadsheet-complete-guide',
    image:
      'https://readdy.ai/api/search-image?query=Aerial%20flat%20lay%20of%20a%20modern%20fashion%20spreadsheet%20on%20a%20laptop%20screen%20surrounded%20by%20sneakers%20hoodie%20and%20sunglasses%20on%20a%20warm%20beige%20linen%20desk%2C%20clean%20editorial%20style%2C%20soft%20natural%20light%20from%20window%2C%20high%20detail%20European%20product%20catalog%20aesthetic&width=800&height=500&seq=art-complete-01&orientation=landscape',
    updated: '2026-08-22',
  },
  {
    slug: 'usfans-review-2026',
    image:
      'https://readdy.ai/api/search-image?query=Modern%20editorial%20scene%20with%20a%20notebook%20showing%20star%20ratings%20next%20to%20a%20parcel%20box%20and%20fashion%20accessories%20on%20a%20soft%20cream%20marble%20surface%2C%20warm%20neutral%20tones%2C%20natural%20daylight%2C%20minimalist%20European%20photography%20style&width=800&height=500&seq=art-review-01&orientation=landscape',
    updated: '2026-08-22',
  },
  {
    slug: 'usfans-shipping-cost-guide',
    image:
      'https://readdy.ai/api/search-image?query=Minimalist%20logistics%20scene%20with%20stacked%20cardboard%20shipping%20boxes%20a%20tape%20measure%20and%20a%20shipping%20label%20printer%20on%20a%20light%20wood%20desk%2C%20clean%20warm%20aesthetic%2C%20soft%20diffused%20lighting%2C%20modern%20European%20catalog%20style&width=800&height=500&seq=art-shipping-01&orientation=landscape',
    updated: '2026-08-22',
  },
  {
    slug: 'usfans-coupon-discount-code-guide',
    image:
      'https://readdy.ai/api/search-image?query=Close-up%20of%20a%20smartphone%20displaying%20a%20coupon%20code%20screen%20next%20to%20a%20credit%20card%20and%20small%20shopping%20bags%20on%20a%20soft%20sage%20linen%20background%2C%20warm%20natural%20light%2C%20minimalist%20editorial%20photography%20style&width=800&height=500&seq=art-coupon-01&orientation=landscape',
    updated: '2026-08-22',
  },
  {
    slug: 'usfans-warehouse-guide',
    image:
      'https://readdy.ai/api/search-image?query=Bright%20clean%20warehouse%20storage%20shelf%20with%20neatly%20stacked%20packaged%20parcels%20and%20a%20digital%20tablet%20showing%20inventory%20on%20a%20minimal%20white%20and%20wood%20surface%2C%20industrial%20modern%20aesthetic%2C%20soft%20natural%20light%2C%20high%20detail%20photography&width=800&height=500&seq=art-warehouse-01&orientation=landscape',
    updated: '2026-08-22',
  },
  {
    slug: 'is-usfans-legit',
    image:
      'https://readdy.ai/api/search-image?query=Conceptual%20security%20scene%20with%20a%20shield%20icon%20badge%20and%20magnifying%20glass%20over%20a%20clean%20document%20on%20a%20pale%20warm%20desk%2C%20soft%20natural%20light%2C%20trustworthy%20minimal%20editorial%20photography%20style%2C%20muted%20earth%20tones&width=800&height=500&seq=art-legit-01&orientation=landscape',
    updated: '2026-08-22',
  },
  {
    slug: 'usfans-qc-guide',
    image:
      'https://readdy.ai/api/search-image?query=Close-up%20macro%20photography%20of%20high-quality%20sneaker%20stitching%20and%20texture%20detail%20with%20a%20small%20camera%20lens%20and%20measurement%20tape%20on%20a%20soft%20cream%20background%2C%20sharp%20detail%2C%20soft%20side%20lighting%2C%20modern%20product%20editorial%20style&width=800&height=500&seq=art-qc-01&orientation=landscape',
    updated: '2026-08-22',
  },
  {
    slug: 'usfans-safety-guide',
    image:
      'https://readdy.ai/api/search-image?query=Modern%20workspace%20with%20a%20laptop%20showing%20a%20lock%20icon%2C%20a%20smartphone%20with%20two-factor%20authentication%2C%20and%20a%20small%20padlock%20on%20a%20warm%20neutral%20linen%20desk%2C%20clean%20minimalist%20aesthetic%2C%20soft%20natural%20lighting%2C%20high%20detail&width=800&height=500&seq=art-safety-01&orientation=landscape',
    updated: '2026-08-22',
  },
  {
    slug: 'usfans-finds-guide',
    image:
      'https://readdy.ai/api/search-image?query=Overhead%20flat%20lay%20of%20curated%20fashion%20finds%20including%20a%20stylish%20watch%2C%20leather%20wallet%2C%20designer%20sunglasses%20and%20a%20folded%20denim%20jacket%20on%20a%20textured%20linen%20surface%2C%20warm%20neutral%20tones%2C%20soft%20natural%20daylight%2C%20editorial%20style&width=800&height=500&seq=art-finds-01&orientation=landscape',
    updated: '2026-08-22',
  },
  {
    slug: 'usfans-categories-guide',
    image:
      'https://readdy.ai/api/search-image?query=Organized%20fashion%20category%20display%20with%20rows%20of%20neatly%20arranged%20sneakers%2C%20hoodies%2C%20caps%20and%20accessories%20on%20white%20shelves%20against%20a%20warm%20cream%20wall%2C%20retail%20boutique%20aesthetic%2C%20soft%20natural%20light%2C%20high%20detail%20photography&width=800&height=500&seq=art-categories-01&orientation=landscape',
    updated: '2026-08-22',
  },
];

export function getArticleBySlug(slug: string): ArticleMeta | undefined {
  return articles.find((a) => a.slug === slug);
}